import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Loading.module.css';
export default function AccountLoading({ id = 'load' }) {
    return (_jsx("div", { className: styles.loadingContainer, "data-testid": id, children: _jsxs("div", { className: styles.loading, children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }) }));
}
